// @flow
import type { GroupedRole, Role } from '../../types/Role'

export const ADMIN: Role = 'admin'
export const DISPATCHER: Role = 'dispatcher'
export const DRIVER: Role = 'driver'
export const PROVIDER: Role = 'provider'
export const REVIEWER: Role = 'reviewer'

export const LOGGED_OUT: GroupedRole = 'LOGGED_OUT'
export const LOGGED_IN: GroupedRole = 'LOGGED_IN'
